/*
SaiKrishna 10/06/2022 2698823069 Removed unnecessary console.log statements
*/
import React, {useContext, useEffect} from 'react';
import {
  Grid,
  Button,
  FormHelperText,
  TextField,
  FormControl,
  FormControlLabel,
  RadioGroup,
  InputAdornment,
  Radio,
} from '@material-ui/core';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import * as Yup from 'yup';
import DateFnsUtils from '@date-io/date-fns';
import {Currency} from '../../../../util/Currency';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import moment from 'moment';
import {Formik, Form} from 'formik';
import {useDispatch, useSelector} from 'react-redux';
import {
  postSubscribeServiceData,
  resetMessage,
  resetStatus,
  saveRateCard,
} from '../../../../redux/reducers/client-maintainance/ClientGeneral';
import PageLoader from '../../../../components/PageLoader';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';

const rateTypeOptions = [
  {value: 'flat', key: 'Flat Fee'},
  {value: 'percentage', key: 'Percentage'},
];


const EditSubServiceTypeDialog = ({
  rowData,
  parentRowData,
  subServiceTypeTableData,
  setSubServiceTypeTableData,
  setEditSubServiceDialog,
  historyData,
  setHistoryData,
  clientNumber,
  handleSubServiceDialog,
  companyType,
  prePopData,
}) => {
  const dispatch = useDispatch();
  const {subscribedService} = rowData;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  let initialValues;
  if (rowData.isCurrentRate) {
    // effectiveDate:  subscribedService? moment(rowData.serviceStartDt).format("MM/DD/YYYY") : null,
    initialValues = {
      endDate: null,
      effectiveDate: null,
      rateType: '',
      value: '',
      serviceStatus: 'renew',
      rateNote: '',
      newEndDate: null,
    };
  } else {
    initialValues = {
      endDate: null,
      effectiveDate:
        prePopData && prePopData?.serviceStartDt ?
          moment(prePopData?.serviceStartDt).format('MM/DD/YYYY') :
          subscribedService ?
            moment(rowData.serviceStartDt).format('MM/DD/YYYY') :
            null,
      rateType:
        prePopData && prePopData?.feeType ?
          prePopData?.feeType.includes('percen') ?
            {
              value: 'percentage',
              key: 'Percentage',
            } :
            {
              value: 'flat',
              key: 'Flat Fee',
            } :
          '',
      value: prePopData && prePopData?.feeValue ? prePopData?.feeValue : '',
      serviceStatus: 'renew',
      rateNote: prePopData && prePopData?.rateNotes ? prePopData?.rateNotes : '',
      newEndDate:
        prePopData && prePopData?.serviceEndDt ? new Date(prePopData?.serviceEndDt) : null,
    };
  }
  const validationSchema = Yup.object().shape({
    rateNote: Yup.string().max(500, 'Note cannot exceed 500 characters'),
    rateType: subscribedService ?
      Yup.object()
        .nullable()
        .when('serviceStatus', {
          is: (val) => val === 'renew',
          then: Yup.object().nullable().required('Rate type is required'),
        }) :
      Yup.object().nullable().required('Rate type is required'),
    value: subscribedService ?
      Yup.string()
        .when('serviceStatus', {
          is: (val) => val === 'renew',
          then: Yup.string().required('Value is required'),
        })
        .test('is not 100', 'Value should not be greater than 100', function(fieldValue, context) {
          if (
            context.parent.rateType &&
              context.parent.rateType.value === 'percentage' &&
              Number(fieldValue) > 100
          ) {
            return false;
          } else {
            return true;
          }
        }) :
      Yup.string()
        .required('Value is required')
        .test('is not 100', 'Value should not be greater than 100', function(fieldValue, context) {
          if (
            context.parent.rateType &&
              context.parent.rateType.value === 'percentage' &&
              Number(fieldValue) > 100
          ) {
            return false;
          } else {
            return true;
          }
        }),
    effectiveDate: subscribedService ?
      null :
      Yup.date()
        .typeError('Invalid Date Format')
        .min(today, 'Start date should not be past date')
        .nullable()
        .required('Effective date is required'),
    endDate:
      subscribedService && rowData.isCurrentRate ?
        Yup.date()
          .typeError('Invalid Date Format')
          .nullable()
          .test('length', 'End date should not be below the Old Effective Date', (date) => {
            const effectiveDate = moment(rowData.serviceStartDt).format('YYYY-MM-DD');
            const endDate = moment(date).format('YYYY-MM-DD');
            if (endDate >= effectiveDate) {
              return true;
            } else {
              return false;
            }
          })
          .required('End date is required') :
        Yup.string()
          .nullable()
          .test('length', 'End date should not be below the Effective Date', function(date, context) {
            const effectiveDate = moment(context.parent.effectiveDate).format('YYYY-MM-DD');
            const endDate = moment(date).format('YYYY-MM-DD');
            if (endDate >= effectiveDate) {
              return true;
            } else {
              return false;
            }
          }),
  });
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {postRateCardStatus, isLoading} = useSelector(({clientGeneral}) => clientGeneral);

  useEffect(() => {
    if (postRateCardStatus && postRateCardStatus?.status === 200) {
      setEditSubServiceDialog(false);
    }
    setTimeout(() => {
      dispatch(resetMessage());
      dispatch(resetStatus());
    }, 3000);
  }, [postRateCardStatus]);

  const onSubmit = (values) => {
    if (subscribedService) {
      const {clientNumber, feeType, feeValue, clientRatecardId, isCurrentRate} =
        rowData;
      const {rateType, value, endDate, effectiveDate, serviceStatus, rateNote, newEndDate} =
        values;
      const format = 'YYYY-MM-DD';
      const payload = {
        clientId: clientNumber,
        feeType: rateType && rateType.value.length > 0 ? rateType.value.toLowerCase() : feeType,
        feeValue: value && value.length > 0 ? value : feeValue,
        rateId: clientRatecardId,
        serviceEndDt: newEndDate && moment(newEndDate).format(format),
        serviceStartDt: effectiveDate ?
          moment(effectiveDate).format(format) :
          moment(getEffectiveDate(values)).format(format),
        // : moment(serviceStartDt).format(format),
        terminated: serviceStatus === 'renew' ? '' : 'Y',
        rateNotes: rateNote,
        endDate: isCurrentRate ?
          moment(endDate).format(format) :
          newEndDate && moment(newEndDate).format(format),
        isCurrentRate: isCurrentRate,
      };
      dispatch(saveRateCard(payload));
    } else {
      const payload = {
        clientCodeSuffix: rowData?.clientCodeSuffix ? rowData?.clientCodeSuffix : '',
        clientId: parentRowData?.clientId ? parentRowData?.clientId : '',
        clientName: parentRowData?.clientName ? parentRowData?.clientName : '',
        // clientServiceId: rowData?.clientServiceId,
        parentClientId: parentRowData?.parentClientId ? parentRowData?.parentClientId : '',
        serviceType: rowData?.serviceType ? rowData?.serviceType : '',
        subServiceType: rowData?.subServiceType ? rowData?.subServiceType : '',
        feeType: values.rateType.value,
        feeValue: values.value,
        rateNotes: values.rateNote,
        serviceStartDt: moment(values.effectiveDate).format('YYYY-MM-DD'),
        serviceEndDt: values.endDate && moment(values.endDate).format('YYYY-MM-DD'),
      };
      dispatch(postSubscribeServiceData(payload));
    }
  };

  const getEffectiveDate = (values) => {
    const {endDate} = values;
    if (endDate) {
      const date = new Date(values.endDate);
      date.setDate(date.getDate() + 1);
      return date;
    } else {
      return null;
    }
  };
  return (
    <div>
      <Formik
        onSubmit={onSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            setFieldValue,
            handleReset,
            handleBlur,
            setTouched,
            touched,
            errors,
            resetForm,
          } = props;
          return (
            <Form noValidate autocomplete="off">
              <div className="col">
                <div className="rate-columns">
                  {subscribedService && rowData.isCurrentRate && (
                    <>
                      <div className="mb-3">
                        <div className="block-styling">
                          {/* <h6>Old Rate Data</h6> */}
                          <div className="rate-headings">Current Rate: </div>

                          <div className="current-rate-table">
                            <div className="form-row">
                              <div className="col-md-3 font-weight-bold pl-3">Rate Type</div>
                              <div className="col-md-3 number-alignment font-weight-bold text-right">
                                Value
                              </div>
                              <div className="col-md-3 font-weight-bold">Start Date</div>
                              <div className="col-md-3 font-weight-bold">End Date</div>
                            </div>
                          </div>
                          <div className="current-rate-table-description">
                            <div className="form-row">
                              <div className="col-md-3 pl-3">
                                {rowData.feeType[0].toUpperCase() + rowData.feeType.slice(1)}
                              </div>
                              <div className="col-md-3 number-alignment font-weight-bold text-right">
                                {rowData?.feeType?.toLowerCase() === 'flat' ?
                                  '$' +
                                    rowData.feeValue.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                    }) :
                                  rowData.feeValue.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                  }) + '%'}
                              </div>
                              <div className="col-md-3">
                                {moment(rowData.serviceStartDt).format('MM/DD/YYYY')}
                              </div>
                              <div className="col-md-3">
                                {rowData?.serviceEndDt ?
                                  moment(rowData.serviceEndDt).format('MM/DD/YYYY') :
                                  ''}
                              </div>
                            </div>
                          </div>

                          <div className="col-sm-6 mt-4 px-0 form-group">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <Grid container>
                                <KeyboardDatePicker
                                  className={` ${classes.labelName} ${classes.datePicker}`}
                                  format="MM/dd/yyyy"
                                  placeholder="MM/DD/YYYY"
                                  fullWidth
                                  value={values.endDate}
                                  name="endDate"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  helperText={null}
                                  required
                                  onBlur={handleBlur}
                                  inputVariant="outlined"
                                  label="End Date"
                                  onChange={(val) => {
                                    setTouched({...touched, endDate: true});
                                    setFieldValue('endDate', val);
                                  }}
                                  autoOk
                                  margin="dense"
                                  touched={touched?.endDate}
                                  error={Boolean(touched?.endDate && errors?.endDate)}
                                />
                              </Grid>
                            </MuiPickersUtilsProvider>
                            <FormHelperText
                              style={{color: 'red'}}
                              margin="dense"
                              variant="outlined"
                            >
                              {touched?.endDate && errors && errors?.endDate}
                            </FormHelperText>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {!rowData?.isCurrentRate && <div className="rate-headings">Update Rate: </div>}

                  <div>
                    {values.serviceStatus === 'renew' && (
                      <>
                        <div className="block-styling">
                          {subscribedService && <div className="rate-headings">New Rate: </div>}

                          <div className="form-row">
                            <div className="col-sm-6  form-group">
                              <FormControl margin="dense" variant="outlined" fullWidth>
                                <GuiAutoComplete
                                  options={rateTypeOptions}
                                  getOptionLabel={(option) => {
                                    return option && option.key && option.key;
                                  }}
                                  classes={{
                                    option: classes.option,
                                  }}
                                  size="small"
                                  autoHighlight
                                  name="rateType"
                                  value={values.rateType}
                                  onBlur={handleBlur}
                                  disabled={values.serviceStatus === 'terminate'}
                                  renderInput={(params) => (
                                    <GuiTextField
                                      className={` multiselect-label ${classes.labelName} ${classes.selectLabel} ${classes.multiselectlabel}`}
                                      {...params}
                                      variant="outlined"
                                      fullWidth
                                      required
                                      label={subscribedService ? 'Rate Type' : 'Rate Type'}
                                      name="rateType"
                                      touched={touched?.rateType}
                                      error={Boolean(touched?.rateType && errors?.rateType)}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      placeholder="Select Rate Type"
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'off',
                                      }}
                                    />
                                  )}
                                  onChange={(_, data) => {
                                    setFieldValue('rateType', data);
                                  }}
                                />
                              </FormControl>
                              <FormHelperText
                                style={{color: 'red'}}
                                margin="dense"
                                variant="outlined"
                              >
                                {touched?.rateType && errors && errors?.rateType}
                              </FormHelperText>
                            </div>

                            <div className="col-sm-6 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                value={values[`value`]}
                                placeholder={`Enter Value`}
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                label={subscribedService ? 'Value' : 'Value'}
                                disabled={values.serviceStatus === 'terminate' || !values.rateType}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                onBlur={handleBlur}
                                required
                                fullWidth
                                touched={touched?.value}
                                error={Boolean(touched?.value && errors?.value)}
                                name={`value`}
                                InputProps={
                                  values[`rateType`] && values[`rateType`].value === 'flat' ?
                                    {
                                      startAdornment: <InputAdornment>$</InputAdornment>,
                                      inputComponent: Currency,
                                    } :
                                    values[`rateType`] &&
                                      values[`rateType`].value === 'percentage' ?
                                      {
                                        endAdornment: <InputAdornment>%</InputAdornment>,
                                        inputComponent: Currency,
                                      } :
                                      {}
                                }
                                onChange={(e) => {
                                  setFieldValue(`value`, e.target.value);
                                }}
                              />
                              <FormHelperText
                                style={{color: 'red'}}
                                margin="dense"
                                variant="outlined"
                              >
                                {touched?.value && errors && errors?.value}
                              </FormHelperText>
                            </div>
                            {subscribedService && values.serviceStatus === 'renew' && (
                              <>
                                <div className="col-sm-6 form-group">
                                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <Grid container>
                                      <KeyboardDatePicker
                                        className={` ${classes.labelName} ${classes.datePicker}`}
                                        format="MM/dd/yyyy"
                                        placeholder="MM/DD/YYYY"
                                        fullWidth
                                        value={
                                          values?.effectiveDate ?
                                            values.effectiveDate :
                                            errors.endDate && errors.endDate?.length > 0 ?
                                              null :
                                              getEffectiveDate(values)
                                        }
                                        minDate={new Date()}
                                        name="effectiveDate"
                                        minDateMessage={null}
                                        error={false}
                                        helperText={null}
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        disabled={prePopData ? false : true}
                                        inputVariant="outlined"
                                        label="Start Date"
                                        onChange={(val) => {
                                          setFieldValue('effectiveDate', val);
                                        }}
                                        autoOk
                                        margin="dense"
                                      />
                                    </Grid>
                                  </MuiPickersUtilsProvider>
                                </div>
                                <div className="col-sm-6 form-group">
                                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <Grid container>
                                      <KeyboardDatePicker
                                        className={` ${classes.labelName} ${classes.datePicker}`}
                                        format="MM/dd/yyyy"
                                        placeholder="MM/DD/YYYY"
                                        fullWidth
                                        value={values.newEndDate}
                                        minDate={getEffectiveDate(values)?.setDate(
                                          getEffectiveDate(values)?.getDate() + 1,
                                        )}
                                        minDateMessage={
                                          'End Date should be greater than Start Date'
                                        }
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        disabled={prePopData ? false : !getEffectiveDate(values)}
                                        inputVariant="outlined"
                                        label="End Date"
                                        onChange={(val) => {
                                          setFieldValue('newEndDate', val);
                                        }}
                                        autoOk
                                        margin="dense"
                                      />
                                    </Grid>
                                  </MuiPickersUtilsProvider>
                                </div>
                              </>
                            )}

                            {!subscribedService && (
                              <>
                                <div className="col-sm-6 form-group">
                                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <Grid container>
                                      <KeyboardDatePicker
                                        className={` ${classes.labelName} ${classes.datePicker}`}
                                        format="MM/dd/yyyy"
                                        placeholder="MM/DD/YYYY"
                                        fullWidth
                                        value={values.effectiveDate}
                                        helperText={null}
                                        required
                                        name="effectiveDate"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        disabled={rowData.subscribedService}
                                        touched={touched?.effectiveDate}
                                        error={Boolean(
                                          touched?.effectiveDate && errors?.effectiveDate,
                                        )}
                                        inputVariant="outlined"
                                        label="Start Date"
                                        onChange={(val) => {
                                          setTouched({...touched, effectiveDate: true});
                                          setFieldValue('effectiveDate', val);
                                        }}
                                        autoOk
                                        margin="dense"
                                      />
                                    </Grid>
                                  </MuiPickersUtilsProvider>
                                  <FormHelperText
                                    style={{color: 'red'}}
                                    margin="dense"
                                    variant="outlined"
                                  >
                                    {touched?.effectiveDate && errors && errors?.effectiveDate}
                                  </FormHelperText>
                                </div>
                                <div className="col-sm-6  form-group">
                                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <Grid container>
                                      <KeyboardDatePicker
                                        className={` ${classes.labelName} ${classes.datePicker}`}
                                        format="MM/dd/yyyy"
                                        placeholder="MM/DD/YYYY"
                                        fullWidth
                                        value={values.endDate}
                                        disabled={!values?.effectiveDate}
                                        minDate={new Date()}
                                        minDateMessage={null}
                                        maxDateMessage={null}
                                        invalidDateMessage={'Invalid Date'}
                                        name="endDate"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        inputVariant="outlined"
                                        label="End Date"
                                        onChange={(val) => {
                                          setFieldValue('endDate', val);
                                        }}
                                        autoOk
                                        margin="dense"
                                      />
                                    </Grid>
                                  </MuiPickersUtilsProvider>
                                  <FormHelperText
                                    style={{color: 'red'}}
                                    margin="dense"
                                    variant="outlined"
                                  >
                                    {errors.endDate ? errors.endDate : ''}
                                  </FormHelperText>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    <div className="col-sm-12 p-0 form-group">
                      <TextField
                        label={subscribedService ? 'Note' : 'Note'}
                        margin="dense"
                        variant="outlined"
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled={companyType === 'The WellFund, LLC'}
                        name="rateNote"
                        placeholder="Enter your note here"
                        multiline
                        fullWidth
                        error={!!errors?.rateNote}
                        maxRows={4}
                        value={values.rateNote}
                        onChange={(e) => {
                          setFieldValue('rateNote', e.target.value);
                        }}
                      />
                      <FormHelperText style={{color: 'red'}} margin="dense" variant="outlined">
                        {errors.rateNote ? errors.rateNote : ''}
                      </FormHelperText>
                    </div>
                  </div>
                </div>
              </div>
              {subscribedService && rowData?.isCurrentRate && (
                <div className="col rate-columns">
                  <FormControl component="div" className={`${classes.radioGroup}`}>
                    <RadioGroup
                      aria-label="serviceStatus"
                      name="serviceStatus"
                      value={values.serviceStatus}
                      onChange={(e) => {
                        handleReset();
                        setFieldValue('serviceStatus', e.target.value);
                      }}
                    >
                      <FormControlLabel
                        className={`${classes.checkRoot} ml-1`}
                        value="renew"
                        control={<Radio color="primary" />}
                        label="Update Rate"
                      />
                      <FormControlLabel
                        className={`${classes.checkRoot} ml-2`}
                        value="terminate"
                        control={<Radio color="primary" />}
                        label="Terminate"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              )}
              <div className="button-spacing-mb">
                <Button
                  type="reset"
                  onClick={() => {
                    resetForm(initialValues);
                    setEditSubServiceDialog(false);
                  }}
                  variant="contained"
                  className={`mx-1 ${classes.buttonRoot}`}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
                >
                  {subscribedService ? 'save' : 'subscribe'}
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
    </div>
  );
};

export default EditSubServiceTypeDialog;
